const base = 'https://assets.smooved.be';
const illustrations = `${base}/illustrations`;
export const assetsImages = `${base}/images`;
export const illustrationRelax = `${illustrations}/smooved-relax.png`;
export const coverImageUrl = `${base}/images/co-pilot-cropped-:languageCode.jpg`
